import { FlexBox, Icon, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { useState } from 'react'
import { analytics } from 'segment_analytics'
import { useStats } from '../../../lib/ctx/stats'
import { OverflowMenu } from '../../shared'

export const ReaderSummaryInfo = () => {
  const [open, setOpen] = useState(false)
  const { nativeOverrides, colors } = useTheme()
  const isSelfView = useStats((s) => s.isSelfView)

  if (!isSelfView) return null

  return (
    <div
      className={css`
        position: relative;
      `}
    >
      <OverflowMenu
        dataTestId="stats-summary-info-button"
        containerStyles={css`
          padding: 22px 12px;
        `}
        align="center"
        open={open}
        setOpen={setOpen}
        onTriggerClick={() => analytics.events.stats.statsSummaryBetaInfo()}
        trigger={
          <FlexBox
            className={css`
              position: relative;
              gap: 2px;
              padding: 2px 2px 2px;
              padding-left: 6px;
              background-color: ${colors.uiWhite20};
              border-radius: 40px;
            `}
            alignItems="center"
          >
            <Text
              className={css`
                font-size: 10px;
                line-height: 12px;
                letter-spacing: 0.5px;
                text-transform: uppercase;
              `}
              type="body"
              weight="600"
              color={colors.uiWhite}
            >
              BETA
            </Text>
            <button className={nativeOverrides.buttonClear}>
              <Icon
                type="info-solid"
                className={css`
                  width: 14px;
                  height: 14px;
                `}
                fill={colors.uiWhite}
              />
            </button>
          </FlexBox>
        }
      >
        <Icon
          type="info-solid"
          fill={colors.uiPewterGrey}
          className={css`
            width: 17px;
            height: 17px;
            margin-bottom: 2px;
          `}
        />
        <Text
          type="body"
          sizing="M"
          color={colors.uiWhite}
          className={css`
            p + p {
              margin-top: 16px;
            }
          `}
        >
          <p>
            <b>How is my Reader Summary generated?</b>
            <br />
            Each Reader Summary was hand-written by our editorial team. An
            algorithm matches you to the most relevant summary in our database,
            based on your recent reading history.
          </p>
          <p>
            <b>How do I give feedback?</b>
            <br />
            Tap the thumbs up or down button to share feedback with our
            editorial team. Want to say more? Email support@fable.co!
          </p>
        </Text>
      </OverflowMenu>
    </div>
  )
}
